import { Card as AntCard, CardProps } from "antd";
import styled from "styled-components";

export const Card: typeof AntCard = styled(AntCard)<CardProps>``;
